var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#1877F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6654 25.2503H27.7487L28.582 21.917H25.6654V20.2503C25.6654 19.3925 25.6654 18.5837 27.332 18.5837H28.582V15.7837C28.3106 15.7477 27.2845 15.667 26.2011 15.667C23.939 15.667 22.332 17.0477 22.332 19.5834V21.917H19.832V25.2503H22.332V32.3337H25.6654V25.2503Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookShare);
export default __webpack_public_path__ + "static/media/facebook-share.f8265a0dad4b0703b35a36a9c5d6e2ee.svg";
export { ForwardRef as ReactComponent };